import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiArrowRight } = FiIcons;

const QuizCTASection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const benefits = [
    "Identify your child's unique developmental profile",
    "Understand which skills need the most support",
    "Get personalized recommendations for next steps",
    "Learn if our approach is right for your family"
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-accent-magenta/5 to-accent-purple/10" ref={ref}>
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <div className="bg-white rounded-2xl p-12 shadow-lg border border-gray-100">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 font-serif">
              Not Sure Where to Start? Take Our <span className="gradient-text">FREE Assessment Quiz</span>
            </h2>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Get personalized insights into your child's development in just 5 minutes.
            </p>

            <div className="grid md:grid-cols-2 gap-4 mb-8 text-left">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={inView ? { opacity: 1, x: 0 } : {}}
                  transition={{ delay: 0.2 + index * 0.1 }}
                  className="flex items-start space-x-3"
                >
                  <SafeIcon icon={FiCheckCircle} className="h-5 w-5 text-green-600 mt-1 flex-shrink-0" />
                  <span className="text-gray-700">{benefit}</span>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.6 }}
              className="space-y-4"
            >
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href="https://www.wethebillions.com/quiz"
                className="inline-flex items-center bg-accent-magenta text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-accent-magenta/90 transition-all duration-200 shadow-lg"
              >
                Take the FREE Quiz
                <SafeIcon icon={FiArrowRight} className="h-5 w-5 ml-2" />
              </motion.a>
              
              <p className="text-sm text-gray-500">
                No email required • Instant results • 100% confidential
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default QuizCTASection;